import { useEffect, useState } from "react";
import RadioGroup from "../../components/Form/RadioGroup";
import Search from "../../components/Form/Search";
import DietItem from "../../components/Items/DietItem";
import Button from "../../components/Form/Button";
import Modal from "../../components/Elements/Modal";
import AddDiets from "../../components/Modals/AddDiets";
import moment from "moment/moment";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast, ToastContainer } from "react-toastify";
import {
  detailsProductIngredient,
  listProductIngredient,
  ordering,
} from "../../helpers/api_helper";
import "react-toastify/dist/ReactToastify.css";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import Pagination from "../../components/Elements/Pagination";
import { Loading } from "../../components/Elements/Loading";
import { Error } from "../../components/Elements/Error";
import { NoData } from "../../components/Elements/NoData";
import Select from 'react-select';
import useDebounce from "../../helpers/useDebounce";

const Diets = () => {
  // Query Client instance
  const queryClient = useQueryClient();

  // For Managing Modals
  const [isAddModal, setIsAddModal] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);

  const [isOne, setDataOne] = useState(false);

  // For pagination
  const [perPages, setPerPages] = useState([
    { label: "10 (Default)", value: 10 },
    { label: 20, value: 20 },
    { label: 50, value: 50 },
    { label: 100, value: 100 },
    { label: "All", value: 999999 },
  ]);
  const [selectedPageOpt, setSelectedPageOpt] = useState([]);

  //Data
  const [dataList, setDataList] = useState([]);
  
  // For Filtering Data 🔍
  const [keyword, setKeyword] = useState("");
  const debouncedSearch = useDebounce(keyword, 300);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [status, setStatus] = useState("");

  console.log(debouncedSearch);
  // To fetch Details of specific items when it needs to be edited
  const [editId, setEditId] = useState("");

  // Static status Radio buttons
  const [statusStatic, setStatusStatic] = useState([
    { _id: "", name: "All", color: "success", current: true },
    { _id: true, name: "Published", color: "success", current: false },
    { _id: false, name: "Draft", color: "warning", current: false },
  ]);


  // Dynamic query key for Diets 🗝️
  const queryDiets = ["diets", debouncedSearch, status, limit, offset];

  // For opening Add Modal althogh not mandetory
  const addModal = () => {
    setIsAddModal(true);
  };

  // For fetching details of item
  const {
    data: details,
    error,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ["details", editId],
    queryFn: async () => detailsProductIngredient({ id: editId }),
    enabled: false,
  });

  // Refetch when editId updates
  useEffect(() => {
    if (editId !== "") {
      refetch();
    }
  }, [editId, refetch]);

  // Diet List Component
  function DietList() {
    // Custom hook for fetching diet list
    function useDiet() {
      return useQuery({
        queryKey: queryDiets,
        queryFn: () =>
          listProductIngredient({
            keyword: keyword,
            type: 3,
            sortByField: "ordering",
            sortByValue: 1,
            status: status,
            limit: limit,
            offset: offset,
          }),
        keepPreviousData: true,
      });
    }

    const { data: diets, error, isFetching } = useDiet();

    useEffect(() => {
      if (!isOne) {
        setDataList(diets?.data);
      }
    }, [isOne, diets?.data]);

    const handleDragEnd = (e) => {
      //console.log(e);
      if (!e.destination) return;
      let tempData = Array.from(dataList);
      let [source_data] = tempData.splice(e.source.index, 1);
      tempData.splice(e.destination.index, 0, source_data);
      // console.log(tempData);
      setDataList([...tempData]);
      let dataArray = [];
      for (let i = 0; i < tempData.length; i++) {
        dataArray.push({ id: tempData[i]._id, ordering: i + 1 });
      }
      // setOrderingData(dataArray);
      onClickSaveOrdering(dataArray);
      setDataOne(true);
    };
    const onClickSaveOrdering = async (orderingData) => {
      const saveOrdering = await ordering({
        orderingData: orderingData,
        tableName: "product_ingredient",
      });

      if (saveOrdering.status === 200) {
        setDataOne(false);
        queryClient.invalidateQueries(queryDiets);
        queryClient.removeQueries({
          queryKey: ["diets"],
          type: "inactive",
        });
        toast.success(saveOrdering.message);
      } else {
        toast.error(saveOrdering.message);
      }
    };
    // Handling loading state 😑
    if (isFetching) {
      return <Loading />
    }

    // Handling error state 🥴
    if (error) {
      return <Error />
    }

    // Check if their is no data 🤨
    else if (diets.data.length === 0) {
      return <NoData /> 
    }

    // Renders the list
    else {
      return (
       

        <>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {dataList &&
                    dataList.length > 0 &&
                    dataList.map((item, index) => (
                      <DietItem
                        key={item._id}
                        index={index}
                        dietId={item._id}
                        image={item?.image}
                        name={item?.title}
                        descriptions={item?.description}
                        addons={item?.addons}
                        createdDate={moment(new Date(item?.created_at)).format(
                          "Do MMM YY"
                        )}
                        updatedDate={moment(new Date(item?.updated_at)).format(
                          "Do MMM YY"
                        )}
                        query={queryDiets}
                        status={item?.status}
                        detailsFetch={refetch}
                        setEditId={setEditId}
                        setEditModal={setIsEditModal}
                      />
                    ))}

                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          {/* For Pagination */}
          <Pagination count={diets.count} limit={limit} offset={offset} setOffset={setOffset} />
        </>
      );
    }
  }

  return (
    <>
      <div className="page-filter mb-3">
        <div className="input-filters d-flex justify-content-between">
        <div className="input-items">
            {perPages && (
              <div className="input">
                <Select
                  className="select-tag"
                  isMulti={false}
                  isClearable={true}
                  options={perPages}
                  value={selectedPageOpt || []}
                  placeholder={"Per Page"}
                  onChange={(e) => {
                    setLimit(e.value);
                    setSelectedPageOpt(e);
                  }}
                />
              </div>
            )}
          </div>
          <div className="input-items">
            <Search
              state={keyword}
              setState={setKeyword}
              placeholder={"Search..."}
            />
          </div>

          <div className="input-items items-end gap-3 ms-auto">
            <Button
              label={""}
              labelClasses={""}
              classes={"px-2"}
              icon={"fa-regular fa-arrow-rotate-right"}
              iconPosition={"left"}
              functions={() => {
                queryClient.invalidateQueries(queryDiets);
                queryClient.removeQueries({
                  queryKey: ["diets"],
                  type: "inactive",
                });
                setOffset(0);
                setKeyword("");
                setStatus("");
                setStatusStatic([]);
                setSelectedPageOpt([]);
                setTimeout(() => {
                  setStatusStatic([
                    { _id: "", name: "All", color: "success", current: true },
                    {
                      _id: true,
                      name: "Published",
                      color: "success",
                      current: false,
                    },
                    {
                      _id: false,
                      name: "Draft",
                      color: "warning",
                      current: false,
                    },
                  ]);
                }, 300);
              }}
            />
            <Button
              label={"Diets"}
              labelClasses={""}
              classes={""}
              icon={"fa-regular fa-plus"}
              iconPosition={"left"}
              functions={addModal}
            />
          </div>
        </div>
        <div className="radio-filters">
          <RadioGroup
            data={statusStatic}
            setData={setStatus}
            inputName={"status"}
          />
        </div>
      </div>

      <div className="diets-list">
        <DietList />
      </div>

      {/* // For add Modal */}
      <Modal
        title={"Add Diets"}
        size={"md"}
        isOpen={isAddModal}
        modalClose={() => setIsAddModal(false)}
      >
        <AddDiets modalClose={() => setIsAddModal(false)} query={queryDiets} />
      </Modal>

      {/* //For Edit Modal */}
      <Modal
        title={"Edit Diets"}
        size={"md"}
        isOpen={isEditModal}
        modalClose={() => setIsEditModal(false)}
      >
        <AddDiets
          modalClose={() => setIsEditModal(false)}
          query={queryDiets}
          details={details}
          isFetching={isFetching}
        />
      </Modal>

      {/* // For Msg Toast (Haiyaa !!!.. Ifykyk) */}
      <ToastContainer theme="dark" position="bottom-center" autoClose={2000} />
    </>
  );
};

export default Diets;
